 <style scoped>
* {
  text-align: left;
}
.van-cell {
  padding: 0;
  line-height: 16px;
}
.van-cell::after {
  border-bottom: none;
}
.van-swipe {
  width: 100%;
  overflow: hidden;
}
.van-swipe img {
  width: 100%;
  height: 100%;
}
.about .van-swipe {
  height: 20rem;
  overflow: hidden;
}
.my-swipe .van-swipe-item {
  color: #fff;
  font-size: 20px;
  line-height: 150px;
  text-align: center;
  background-color: #39a9ed;
}
.aboutDetail {
  padding: 10px;
  padding-bottom: 15px;
  border-bottom: 1px solid #a41a1a;
  overflow: hidden;
}
.aboutDetailTitle {
  color: #010003;
  font-size: 1.5rem;
  margin-bottom: 1.7rem;
}
.aboutDetailMoney {
  color: #b80c0c;
  font-size: 1.5rem;
  margin-bottom: 1.3rem;
}
.aboutDetailist {
  overflow: hidden;
}
.aboutDetailist dl {
  float: left;
  width: 40%;
  display: -webkit-box;
  -webkit-box-orient: horizontal;
  margin-bottom: 1.3rem;
  line-height: 2.2rem;
}
.aboutDetailist dl:nth-child(odd) {
  width: 60%;
}
.aboutDetailist dl dt {
  color: #a6a1a1;
  -webkit-box-align: center;
  width: auto;
  font-size: 1.3rem;
}
.aboutDetailist dl dd {
  color: #151414;
  -webkit-box-align: center;
  -webkit-box-flex: 1;
  font-size: 1.3rem;
}
.van-skeleton__row {
  height: 190px;
  width: 100% !important;
}
.bewrite {
  padding: 10px;
  border-bottom: 1px solid #a41a1a;
  padding-bottom: 2rem;
}
.bewriteTtile {
  color: #070707;
  font-size: 1.5rem;
  margin-top: 1rem;
  margin-bottom: 2rem;
}
.bewriteTtile.out {
  margin-bottom: 1rem;
}
.bewriteDetail {
  color: #151414;
  font-size: 1.3rem;
  line-height: 2rem;
}
.aboutList {
  padding: 10px;
  border-bottom: 1px solid #a41a1a;
}
.aboutList.recommend {
  border-bottom: none;
}
.aboutList.recommend .bewriteTtile {
  color: #1989fa;
}
.van-list {
  overflow: hidden;
}
.van-list .van-cell {
  float: left;
  width: 48.5%;
  margin-bottom: 1rem;
}
.van-list .van-cell:nth-child(odd) {
  margin-right: 3%;
}
.aboutList-pictrue img {
  width: 100%;
  background: #ccc;
  height: 9.6rem;
}
.aboutList-money {
  color: #a41a1a;
  font-size: 1.36rem;
  margin-top: 0.5rem;
  display: block;
}
.aboutList-pag {
  color: #070606;
  font-size: 1.1rem;
  padding-top: 0.5rem;
}
.van-goods-action {
  border-top: 1px solid #a41a1a;
}
.van-button {
  border-radius: 0;
}
.van-goods-action-button--first {
  margin-right: 5px;
}
.logoMin {
  width: 4rem;
  margin-left: 8px;
}
.contactsName {
  color: #070606;
  margin-left: 7px;
  margin-right: 3px;
  font-size: 1.2rem;
  color: #070606;
}
.van-goods-action {
  height: 58px;
}
.phoneBtn {
  color: #fff;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.aboutList-cases {
  color: #aaa3a3;
  font-size: 1.1rem;
  margin-top: 0.3rem;
}
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.block {
  width: 150px;
  height: 180px;
  padding: 10px;
  background-color: #fff;
}
.block img {
  width: 100%;
}
.block p {
  text-align: center;
  font-size: 14px;
  color: #444;
  padding-top: 10px;
}
.van-overlay {
  z-index: 10;
}
.van-goods-action {
  z-index: 9;
}
</style>
<template>
  <div class="about">
    <template v-if="info">
      <van-skeleton :row="1" :loading="loading">
        <van-swipe :autoplay="3000">
          <van-swipe-item
            v-for="(image, index) in info.Images"
            :key="index"
            indicator-color="red"
            width="100"
          >
            <img :src="image" />
          </van-swipe-item>
        </van-swipe>
      </van-skeleton>
      <div class="aboutDetail">
        <h2 class="aboutDetailTitle">{{ info.Title }}</h2>
        <h3 class="aboutDetailMoney">{{~[3,7,8].indexOf(info.Category) ? info.Rant : info.Price }}</h3>
        <div class="aboutDetailist">
          <dl>
            <dt>房型：</dt>
            <dd>{{ info.Specs }}</dd>
          </dl>
          <dl>
            <dt>装修：</dt>
            <dd>{{ info.FixLevel }}</dd>
          </dl>
          <dl>
            <dt>面积：</dt>
            <dd>{{ info.Area }}平方米</dd>
          </dl>
          <dl>
            <dt>朝向：</dt>
            <dd>{{ info.Direction }}</dd>
          </dl>
          <dl>
            <dt>楼层：</dt>
            <dd>{{ info.Floor }}</dd>
          </dl>
          <dl>
            <dt>年代：</dt>
            <dd>{{ info.Years }}</dd>
          </dl>
          <dl>
            <dt>小区：</dt>
            <dd>{{ info.Building }}</dd>
          </dl>
          <dl>
            <dt>商圈：</dt>
            <dd>{{ info.TradeArea }}</dd>
          </dl>
          <dl v-if="~[4,6,7,8].indexOf(info.Category) ">
            <dt>使用率：</dt>
            <dd>{{ info.UseRate }}</dd>
          </dl>
          <dl v-if="~[4,6,7,8].indexOf(info.Category) ">
            <dt>物业费：</dt>
            <dd>{{ info.PropertyFee }}</dd>
          </dl>
          <dl v-if="~[6,8].indexOf(info.Category) ">
            <dt>工位数：</dt>
            <dd>{{ info.Station }}</dd>
          </dl>
          <dl>
            <dt>更新：</dt>
            <dd>{{ info.CreatedTime.substr(0, 10) }}</dd>
          </dl>
        </div>
      </div>
      <div class="bewrite">
        <h3 class="bewriteTtile">房源描述</h3>
        <section class="bewriteDetail">
          <van-field
            v-model="info.Feature"
            rows="1"
            autosize
            readonly
            type="textarea"
            placeholder="没有描述..."
          />
        </section>
      </div>
      <div id="container" style="width:100%; height:200px" v-html="loadMap()"></div>
      <div class="aboutList" v-if="building && building.length">
        <h3 class="bewriteTtile out">本小区在租房源</h3>
        <van-list>
          <van-cell
            v-for="(item, index) in building"
            :key="index"
            @click="$router.push({ name: 'About', query: { id: item.ID } })"
          >
            <div class="aboutList-pictrue">
              <img :src="item.Images" />
            </div>
            <p class="aboutList-pag">{{ item.Specs }}&nbsp;{{ item.Area }}平米</p>
            <span class="aboutList-money">{{ item.Price }}</span>
          </van-cell>
        </van-list>
      </div>
      <div class="aboutList recommend" v-if="recommend && recommend.length">
        <h3 class="bewriteTtile out">其他推荐房源</h3>
        <van-list>
          <van-cell
            v-for="(item, index) in recommend"
            :key="index"
            @click="$router.push({ name: 'About', query: { id: item.ID } })"
          >
            <div class="aboutList-pictrue">
              <img :src="item.Images" />
            </div>
            <p class="aboutList-pag">{{ item.Specs }}&nbsp;{{ item.Area }}平米</p>
            <p class="aboutList-cases">{{ item.Building }}</p>
            <span class="aboutList-money">{{ item.Price }}</span>
          </van-cell>
        </van-list>
      </div>
      <van-goods-action>
        <img src="../assets/images/logoMin.png" class="logoMin" />
        <span class="contactsName">
          {{ info.Name }}
          <br />客户代表
        </span>
        <van-goods-action-button
          type="warning  "
          text="在线聊"
          icon="chat-o"
          color="#ffb725"
          @click="showDialog"
        />
        <van-goods-action-button
          type="danger"
          icon="phone-o"
          color="#ff4733"
          style="positon: relative"
        >
          打电话
          <a class="phoneBtn" :href="'tel:' + info.TelPhone"></a>
        </van-goods-action-button>
      </van-goods-action>
      <van-overlay :show="show" @click="showCsole">
        <div class="wrapper">
          <div class="block">
            <img :src="info.QRCode" />
            <p>长按识别二维码</p>
          </div>
        </div>
      </van-overlay>
    </template>
    <van-overlay :show="overlayShow" @click="show = false">
      <div class="wrapper">
        <van-loading color="#fff" size="40px" />
      </div>
    </van-overlay>
  </div>
</template>


<script>
import apis from "@/apis.js";
import BMapGL from "BMapGL";
import area from "@/assets/area.js";
import wx from "wx";
import logo from "../assets/images/logo.png";
export default {
  data() {
    return {
      info: null,
      recommand: null,
      building: null,
      loading: true,
      show: false,
      overlayShow: true,
    };
  },
  mounted() {
    this.loading = false;
  },
  methods: {
    showDialog() {
      var _this = this;
      _this.show = true;
      console.info(this.info);
    },
    showCsole() {
      var _this = this;
      _this.show = false;
    },
    load: function () {
      var _this = this;
      _this.overlayShow = true;
      _this.info = null;
      apis.detail(this.$route.query.id).then(function (e) {
        _this.overlayShow = false;
        _this.info = e.info[0];
        _this.info.Images = JSON.parse(_this.info.Images);
        _this.recommend = e.recommend;
        _this.building = e.building;
        console.log(
          _this.info.Images[0] ? location.origin + _this.info.Images[0] : ""
        );
        _this.share(
          e.info[0].Title,
          e.info[0].Feature,
          _this.info.Images[0] ? location.origin + _this.info.Images[0] : ""
        );
      });
    },
    share: function (title, desc, imgUrl) {
      var that = this;
      apis.share().then(function (e) {
        console.info(e);
        wx.config({
          debug: false, // 开启调试模式,
          appId: e.appId, // 必填，企业号的唯一标识，此处填写企业号corpid
          timestamp: e.timestamp, // 必填，生成签名的时间戳
          nonceStr: e.nonceStr, // 必填，生成签名的随机串
          signature: e.signature, // 必填，签名，见附录1
          jsApiList: ["onMenuShareTimeline", "onMenuShareAppMessage"], // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
        });

        wx.ready(function () {
          // 分享到朋友圈
          wx.onMenuShareTimeline({
            title: title, // 分享标题
            desc: desc, // 分享描述
            link: window.location.href, // 分享链接
            imgUrl: imgUrl, // 分享图标
            success: function () {
              alert("分享成功-");
            },
            cancel: function () {
              // 用户取消分享后执行的回调函数
            },
          });

          //分享给朋友
          wx.onMenuShareAppMessage({
            title: title, // 分享标题
            desc: desc, // 分享描述
            link: window.location.href, // 分享链接
            imgUrl: imgUrl, // 分享图标
            // type: 'link', // 分享类型,music、video或link，不填默认为link
            // dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
            success: function () {
              alert("分享成功-");
            },
            cancel: function () {
              // 用户取消分享后执行的回调函数
            },
          });
        });
      });
    },

    loadMap: async function () {
      await this.$nextTick();

      var map = new BMapGL.Map("container");
      map.centerAndZoom(new BMapGL.Point(116.331398, 39.897445), 12);
      //创建地址解析器实例
      var myGeo = new BMapGL.Geocoder();
      // 将地址解析结果显示在地图上，并调整地图视野
      var provinceName = "中国";
      for (var p in area.province_list) {
        if (p == this.info.Province) {
          provinceName = area.province_list[p];
        }
      }
      var address = this.info.Address;
      var name = this.info.Building;
      myGeo.getPoint(
        this.info.Address,
        function (point) {
          if (point) {
            map.centerAndZoom(point, 16);
            map.addControl(new BMapGL.ScaleControl()); // 添加比例尺控件

            var ComplexCustomOverlay = function (point, text, mouseoverText) {
              this._point = point;
              this._text = text;
              this._overText = mouseoverText;
            };
            ComplexCustomOverlay.prototype = new BMapGL.Overlay();
            ComplexCustomOverlay.prototype.initialize = function (mp) {
              this._map = mp;
              var div = (this._div = document.createElement("div"));
              div.style.position = "absolute";
              div.style.zIndex = BMapGL.Overlay.getZIndex(this._point.lat);
              div.style.backgroundColor = "#EE5D5B";
              div.style.border = "1px solid #BC3B3A";
              div.style.color = "white";
              div.style.height = "18px";
              div.style.padding = "2px";
              div.style.lineHeight = "18px";
              div.style.whiteSpace = "nowrap";
              div.style.MozUserSelect = "none";
              div.style.fontSize = "12px";
              var span = (this._span = document.createElement("span"));
              div.appendChild(span);
              span.appendChild(document.createTextNode(this._text));
              var arrow = (this._arrow = document.createElement("div"));
              arrow.style.background =
                "url(//map.baidu.com/fwmap/upload/r/map/fwmap/static/house/images/label.png) no-repeat";
              arrow.style.position = "absolute";
              arrow.style.width = "11px";
              arrow.style.height = "10px";
              arrow.style.top = "22px";
              arrow.style.left = "10px";
              arrow.style.overflow = "hidden";
              div.appendChild(arrow);
              map.getPanes().labelPane.appendChild(div);
              return div;
            };
            ComplexCustomOverlay.prototype.draw = function () {
              var map = this._map;
              var pixel = map.pointToOverlayPixel(this._point);
              this._div.style.left =
                pixel.x - parseInt(this._arrow.style.left) + "px";
              this._div.style.top = pixel.y - 30 + "px";
            };

            var myCompOverlay = new ComplexCustomOverlay(point, name, address);
            map.addOverlay(myCompOverlay);
          }
        },
        provinceName
      );
    },
  },
  watch: {
    "$route.query.id": "load",
  },
  created: function () {
    this.load();
  },
};
</script>
